/**
 * @desc 批量解绑交货单
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBox/batchUnBindDono`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
